<template>
  <div class="chart-container">
    <div class="select-semester" v-if="currentIndex == 2">
      <a-select
        label-in-value
        :default-value="{ key: termList[0] ? termList[0].value : termList.length }"
        style="width: 120px"
        @change="handleChange"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      >
        <a-select-option :value="term.value" v-for="term in termList" :key="term.value">
          {{ term.name }}
        </a-select-option>
      </a-select>
    </div>
    <div class="count-info" v-if="currentIndex == 3">
      总计
      <span class="video-num">
        数量:
        <span>{{ tranNumber(sourceTotal.videoNum) }}</span>
        个
      </span>
      <span class="video-storge">
        存储:
        <span>{{ sourceTotal.videoStorage }}</span>
        TB
      </span>
    </div>
    <div class="chart-content" :id="`review-chart-${currentIndex}`"></div>
  </div>
</template>

<script>
export default {
  name: 'reviewChart',
  props: {
    currentIndex: {
      type: Number
    },
    chartData: {
      type: Object
    },
    termList: {
      type: Array
    },
    sourceTotal: {
      type: Object
    }
  },
  data() {
    return {
      myChart: null,
      timerIdInitData: 0
      //   chartBox: {
      //     chartWidth: 0,
      //     chartHeight: 0
      //   }
    }
  },
  mounted() {
    this.initCharts()
  },
  watch: {
    chartData: {
      handler(newVal) {
        newVal && this.myChartSetOption()
      },
      deep: true
    }
  },
  methods: {
    // getBoxSize() {
    //     let domList = document.getElementsByClassName('chart-container')
    //     console.log(domList);
    //     this.chartBox.chartWidth = domList[0].clientWidth
    //     this.chartBox.chartHeight = domList[0].clientHeight
    // },
    initCharts() {
      let myChart = null
      if (this.myChart) {
        myChart = this.myChart
      } else {
        myChart = this.myChart = this.$echarts.init(document.getElementById(`review-chart-${this.currentIndex}`))
      }
      window.addEventListener('resize', function () {
        myChart.resize()
      })
      this.myChartSetOption()
    },
    myChartSetOption() {
      if (!this.myChart) return
      if (this.chartData.chartOptions) {
        let option = {
          width: '86%',
          height: '65%',
          grid: {
            left: 48,
            right: 40
          },
          title: {
            text: this.chartData.title,
            textStyle: {
              color: '#1E2228',
              fontSize: 16
            },
            padding: 16
          },
          legend: {
            data: this.chartData.chartOptions.legend?.data,
            align: 'left',
            padding: [18, 0, 0, 0],
            right: '16',
            itemWidth: 10,
            itemHeight: 10,
            icon: 'rect',
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2
            },
            textStyle: {
              fontSize: 12,
              color: '#999BA8'
            }
          },
          tooltip: this.chartData.chartOptions.tooltip ? this.chartData.chartOptions.tooltip : undefined,
          xAxis: {
            type: 'category',
            data: this.chartData.chartOptions.xAxis.data,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#D4DAE3'
              }
            },
            axisLabel: {
              color: '#999BA8',
              interval: this.chartData.chartOptions.xAxis.data.length > 8 && this.currentIndex !== 0 ? 1 : 0,
              rotate: this.chartData.chartOptions.xAxis.data.length > 8 ? 30 : undefined,
              width:
                this.currentIndex === 0 ? (this.chartData.chartOptions.xAxis.data.length > 8 ? 50 : 70) : undefined,
              overflow: this.currentIndex === 0 ? 'truncate' : undefined
            }
          },
          yAxis: this.chartData.chartOptions.yAxis,
          series: this.chartData.chartOptions.series
        }
        console.log('option🐶:>>>>>>>', option, 'src/views/OperationOverview/components/ChartRender.vue')

        // 使用刚指定的配置项和数据显示图表。
        // this.myChart.clear()
        this.myChart.setOption(option, true)
      }
    },
    handleChange(item) {
      console.log('value🐶:>>>>>>>', item, 'src/views/OperationOverview/components/ChartRender.vue')
      this.$emit('changeTermData', item.key)
    },
    tranNumber(num, point) {
      if (!num) return
      // 将数字转换为字符串,然后通过split方法用.分隔,取到第0个
      let numStr = num.toString().split('.')[0]
      let decimal
      if (numStr.length < 5) {
        // 判断数字有多长,如果小于5,,表示1万以内的数字,让其直接显示
        return numStr
      } else if (numStr.length >= 5 && numStr.length <= 8) {
        // 如果数字大于5位,小于8位,让其数字后面加单位万
        decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
        // 由千位,百位组成的一个数字
        return parseFloat(parseInt(num / 10000) + '.' + decimal) + '万'
      } else if (numStr.length > 8) {
        // 如果数字大于8位,让其数字后面加单位亿
        decimal = numStr.substring(numStr.length - 8, numStr.length - 8 + point)
        return parseFloat(parseInt(num / 100000000) + '.' + decimal) + '亿'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  //   max-width: 856px;
  //   min-width: 536px;
  width: 100%;
  height: 100%;
  position: relative;
  .chart-content {
    // max-width: 856px;
    width: 100%;
    // min-width: 536px;
    width: 100%;
    height: 100%;
  }
  .count-info {
    position: absolute;
    top: 16px;
    left: 128px;
    height: 16px;
    font-size: 12px;
    color: #1e2228;
  }
  .select-semester {
    position: absolute;
    top: 10px;
    right: 16px;
    z-index: 1;
    width: 200px;
    height: 32px;
  }
  .video-storge,
  .video-num {
    margin-left: 6px;
  }
  canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
::v-deep .ant-select {
  width: 200px !important;
}
</style>
